import { useCallback } from 'react';

import { FormContextValues } from '@dreryk/react-common';

import { receptionServiceTranslationKeys } from '../../../translations';

import { ReceptionServiceNameValue } from './components/ReceptionServiceNameTextInput';

export type NotUniqueReceptionServiceNameErrorHandlerProp = {
   setNotUniqueReceptionServiceNameError: VoidFunction;
};

export const useNotUniqueReceptionServiceNameErrorHandler = (
   setError: FormContextValues<{ name: ReceptionServiceNameValue | null }>['setError']
): VoidFunction => {
   return useCallback(() => {
      setError('name', {
         message: receptionServiceTranslationKeys.shared.form.errors.notUniqueName,
      });
   }, [setError]);
};
